module.exports = __webpack_public_path__ + "img/Step2.ef0e273.svg";